import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class CorrectionRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Típus</TableCell>
                            <TableCell>Partner</TableCell>
                            <TableCell>Megjegyzés</TableCell>
                            <TableCell>Összeg</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell>{this.props.row.pettyCashTypeLabel}</TableCell>
                            <TableCell></TableCell>
                            <TableCell>{this.props.row.comment}</TableCell>
                            <TableCell>{this.props.row.amount}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default CorrectionRow;